import * as React from "react"

function EmptyCart(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={127}
      height={154}
      viewBox="0 0 127 154"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x={7.67}
        y={28.51}
        width={74.82}
        height={102.87}
        rx={9.5}
        transform="rotate(-7.5 38.532 86.57)"
        fill="none"
        strokeWidth={3}
      />
      <rect
        x={82.26}
        y={24.03}
        width={16}
        height={3}
        rx={1.5}
        transform="rotate(-7.5 83.77 32.229)"
        stroke="none" 
      />
      <path
        d="M62.55.01a1.51 1.51 0 011.69 1.3l1.69 12.9a1.5 1.5 0 01-1.29 1.69 1.5 1.5 0 01-1.68-1.29L61.26 1.7A1.51 1.51 0 0162.55.01zM85.26 5.12a1.5 1.5 0 01.27 2.09l-7.91 10.33a1.5 1.5 0 01-2.1.28 1.5 1.5 0 01-.28-2.1L83.16 5.4a1.5 1.5 0 012.1-.28zM28.41 44.92l33.66-4.43a2 2 0 012.21 1.72 2 2 0 01-1.72 2.24l-33.62 4.43a2 2 0 01-2.25-1.67 2 2 0 011.72-2.29zM33.98 73.94l33.63-4.43a2 2 0 012.24 1.7 2 2 0 01-1.72 2.24L34.5 77.9a2 2 0 01-2.24-1.69 2 2 0 011.72-2.27zM36.97 102.9l33.63-4.43a2 2 0 012.24 1.74 2 2 0 01-1.72 2.24l-33.62 4.43a2 2 0 01-2.25-1.72 2 2 0 011.72-2.26zM29.46 52.84l6.92-.91a2 2 0 012.24 1.72 2 2 0 01-1.72 2.24l-6.92.91a2 2 0 01-2.24-1.72 2 2 0 011.72-2.24z"
        stroke="none"
      />
      <rect
        x={17.7}
        y={76.76}
        width={11.97}
        height={11.98}
        rx={2}
        transform="rotate(-7.5 17.202 89.386)"
        stroke="none"
      />
      <rect
        x={21.69}
        y={105.72}
        width={11.97}
        height={11.98}
        rx={2}
        transform="rotate(-7.5 21.125 118.373)"
        stroke="none"
      />
      <rect
        x={12.71}
        y={46.81}
        width={11.97}
        height={11.98}
        rx={2}
        transform="rotate(-7.5 12.19 59.485)"
        stroke="none"
      />
      <path
        d="M35.07 81.86l6.92-.91a2 2 0 012.24 1.72 2 2 0 01-1.72 2.24l-6.92.91a2 2 0 01-2.24-1.72 2 2 0 011.72-2.24zM38.07 110.82l6.91-.91a2 2 0 012.25 1.72 2 2 0 01-1.72 2.24l-6.92.91a2 2 0 01-2.24-1.72 2 2 0 011.72-2.24z"
        stroke="none" 
      />
      <path
        d="M36.5 130.56l-1.71.3c0 .22.08.39.12.54l1.65-.41zM34.92 131.49zM37.74 130.34l-.29.05h.29z"
        stroke="none" 
      />
      <path
        d="M105.52 38.1l-29.7-1.3v4.5h-.44l9.85 74.74a8 8 0 01-6.89 9l-40.6 5.35h-.29l-1 .13.06.47-1.65.41a10.51 10.51 0 0010.21 8.15l56 2.45h.49a11 11 0 0011-10.52l3.51-81.91a11 11 0 00-10.55-11.47zm4 93.27a8 8 0 01-8.34 7.64l-55.95-2.46a7.85 7.85 0 01-6.33-3.34l39.83-5.24a11 11 0 009.47-12.34l-10-75.74 27.16 1.19a8 8 0 017.71 8.36z"
        stroke="none"
        
      />
    </svg>
  )
}

const MemoEmptyCart = React.memo(EmptyCart);
export default MemoEmptyCart;
